import React, { useMemo } from "react";
import AreaChart from "../../components/Charts/AreaChart";
import { retentionAndChurnProps } from "../../components/Charts/ChartConfig";
import { MuiLoader } from "../../Utils/common";

const RetentionGraph = ({ name, dateRange, data, loading }) => {
  const renderRetentionGraph = useMemo(() => {
    return {
      ...retentionAndChurnProps,
      ...data,
    };
  }, [data]);
  return (

    <div className="chart-parent">
      <div className="chat-infos">
        <h6> {name} </h6>
      </div>

      {loading ?
        <MuiLoader size={40} message="Fetching data...." />
        :
        <AreaChart
          dateRange={dateRange}
          {...renderRetentionGraph}
          showMarkers={true}
          showNameLabel={true}
          chartType="line"
          width="100%"
        />
      }


    </div>

  );
};

export default RetentionGraph;
